import { WizCommand } from '@wizeoo/akm-component-lib';
import { DataLoadObj } from '@wizeoo/akm-compute-lib';
import { BaselineLite, BaselineCriteria } from '@wizeoo/akm-message-lib';
import { DataMessage } from '../../manager/baselines/data.message';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';

/** chargement d'un paquet de baselines */
export class FindDataLinesCommand extends WizCommand<BaselineLite[]>{
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }

  public dlo: DataLoadObj; // la conf d'appel


  /**
   * chargement des baselines
   */
  public find(dlo: DataLoadObj, pageIdx: number, pageSize: number): FindDataLinesCommand {
    this.dlo = dlo;
    
    const criteria: BaselineCriteria = new BaselineCriteria();
    criteria.domain = dlo.visionStep.domain;
    criteria.businessUnitCode = dlo.visionStep.businessUnitCode;
    criteria.visionCode = dlo.visionStep.visionCode;
    criteria.chronoCode = dlo.visionStep.chronoCode;
    criteria.scenarioCode = dlo.scenario;
    criteria.level = dlo.visionStep.level;
    criteria.revisionNumber = dlo.revisionNumber;
    criteria.pageIndex = pageIdx;
    criteria.pageSize = pageSize;

    // TODO contrôler GDM
    // criteria.keyLikes = this.model.connectedUser.getVisionRestrictTags();

    
    this.configureRemote(ExternalAPI.DATA_LITE_API, criteria);
    return this;
  }

  public resolve(): void {
    this.result.forEach((bl: BaselineLite) => {
      this.dlo.remoteBaselines[bl.key] = bl; // alimentation du remote
    });
  }

  wizResult() {
    if (!!this.result) {
      this.dlo.loadedRemoteLines += this.result.length;
      // console.log('datalines', this.dlo.uniqueKey, this.dlo.loadedRemoteLines);
      this.model.dataMessage.doMessage(DataMessage.LOAD_REMOTE_RUNNING, this.dlo);
    }
    super.wizResult();
  }

}
